var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _rect2, _path13, _path14, _path15, _path16, _circle, _path17, _rect3, _rect4, _path18, _path19, _path20, _path21, _ellipse, _path22, _path23, _path24, _circle2, _path25, _rect5, _rect6, _path26, _path27, _path28, _path29, _path30, _path31;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 767,
    height: 683,
    viewBox: "0 0 767 683",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M768.38272,721.626H392.132A48.17953,48.17953,0,0,1,344.007,673.5009V231.62509A48.17954,48.17954,0,0,1,392.132,183.5h350.0398l74.336,59.2506V673.5009A48.17953,48.17953,0,0,1,768.38272,721.626Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M392.13188,197.35419a34.30959,34.30959,0,0,0-34.27089,34.2709V673.5009a34.30958,34.30958,0,0,0,34.27089,34.27089H768.38257a34.30959,34.30959,0,0,0,34.2709-34.27089V249.4249l-65.32783-52.07071Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M689.879,325.83982H437.57728a8.01412,8.01412,0,1,1,0-16.02823H689.879a8.01411,8.01411,0,0,1,0,16.02823Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M722.93717,352.88745H437.57728a8.01411,8.01411,0,1,1,0-16.02822H722.93717a8.01411,8.01411,0,1,1,0,16.02822Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M689.879,447.05329H437.57728a8.01412,8.01412,0,1,1,0-16.02823H689.879a8.01411,8.01411,0,0,1,0,16.02823Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#01bf71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M722.93717,474.10092H437.57728a8.01411,8.01411,0,1,1,0-16.02822H722.93717a8.01411,8.01411,0,1,1,0,16.02822Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M689.879,568.26676H437.57728a8.01411,8.01411,0,1,1,0-16.02823H689.879a8.01411,8.01411,0,0,1,0,16.02823Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M722.93717,595.31439H437.57728a8.01412,8.01412,0,1,1,0-16.02823H722.93717a8.01411,8.01411,0,1,1,0,16.02823Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M815.06081,244.65744H756.831a16.02823,16.02823,0,0,1-16.02823-16.02823V185.62145a1.00177,1.00177,0,0,1,1.62383-.78522l73.25631,58.03422A1.00177,1.00177,0,0,1,815.06081,244.65744Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M449.5,221.5a110,110,0,1,1-110-110A110.03473,110.03473,0,0,1,449.5,221.5Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M390.34005,240.32207c-1.20146,70.35087-105.847,70.33985-107.03822-.00226C284.50321,169.9712,389.14878,169.98222,390.34005,240.32207Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#01bf71"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M334.69646,262.15806l-.05567-2c13.78448,1.84042,16.75313-15.24334,2.85156-8.85645l3.17334-23.19042,1.98145.27148-2.69922,19.72656C354.58511,245.93044,349.171,264.15688,334.69646,262.15806Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 135.94646,
    y: 121.58384,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 101.94646,
    y: 121.58384,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M354.16992,315.15c2.1001-14.17-14.48974-11.37-23.27-11.51a9.518,9.518,0,0,0-9.27978,11.5,52.03823,52.03823,0,0,0-18.49024,10.2,110.47619,110.47619,0,0,0,70.43018.78A51.77077,51.77077,0,0,0,354.16992,315.15Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M311.65924,215.00889c9.91839-5.73222,21.94644-1.33459,32.19176,1.06974,19.43829,5.97549,46.69691-1.50709,49.06067-24.66246,2.45988-21.53491-26.99911-33.53711-36.41493-12.10366l2.74162-.35832c-30.53675-45.38215-83.65461-43.661-83.30532,18.73141-.11322,1.92749,2.88716,1.921,2.99939-.00115-1.12422-36.76687,23.20863-61.89966,57.60511-38.27163,7.87161,5.7434,14.24117,13.35026,20.11041,21.05553,3.58222,4.01446,4.36067-13.27438,21.50583-8.746,18.86877,7.31,12.712,34.32849-4.15335,40.2598-20.83848,10.64622-43.40723-9.9954-63.8555.435a1.50174,1.50174,0,0,0,1.51431,2.59172Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M339.5,334.5a112.90492,112.90492,0,1,1,34.98755-5.52686A112.72659,112.72659,0,0,1,339.5,334.5Zm0-220a107.01519,107.01519,0,1,0,107,107A107.12118,107.12118,0,0,0,339.5,114.5Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M980.5,447.5a110.03473,110.03473,0,0,1-75.93994,104.62c-.66016.21-1.31983.42-1.99024.62-2.85986.88-5.75976,1.63-8.71,2.27a108.13332,108.13332,0,0,1-16.21,2.25q-3.55445.24-7.1499.24a109.80845,109.80845,0,0,1-36.37012-6.16c-.33984-.12006-.67968-.24-1.00976-.36005A110.01069,110.01069,0,1,1,980.5,447.5Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 651.36456,
    cy: 358.36027,
    r: 53.51916,
    fill: "#01bf71"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M870.989,495.69626l.05566-2c-3.7207-.10351-7.001-.33691-9.46582-2.13769a6.148,6.148,0,0,1-2.38135-4.52832,3.51435,3.51435,0,0,1,1.15284-2.89453c1.63623-1.38184,4.269-.93457,6.188-.05469l1.65479.75879-3.17334-23.19043-1.98145.27148,2.69922,19.72657c-2.60742-.76661-5.02343-.43653-6.67822.96093a5.471,5.471,0,0,0-1.86035,4.49219,8.13266,8.13266,0,0,0,3.20019,6.07324C863.56616,495.48826,867.68188,495.60349,870.989,495.69626Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 625.96752,
    y: 355.12204,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 659.96752,
    y: 355.12204,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M883.06982,541.68a9.78916,9.78916,0,0,0,.22022-2,9.515,9.515,0,0,0-9.5-9.5h-14a9.50845,9.50845,0,0,0-9.5,9.5,9.23864,9.23864,0,0,0,.21973,2.01,53.738,53.738,0,0,0-14.80957,7.33c-.88038.61-1.75,1.27-2.58008,1.96.33008.12.66992.24,1.00976.36005A109.80845,109.80845,0,0,0,870.5,557.5q3.59985,0,7.1499-.24a108.13332,108.13332,0,0,0,16.21-2.25c2.9502-.64,5.8501-1.39,8.71-2.27A54.19775,54.19775,0,0,0,883.06982,541.68Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M881.27,555.99a7.35862,7.35862,0,0,0-3.62012,1.27,108.13332,108.13332,0,0,0,16.21-2.25Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M916.40315,454.14664,823.42927,420.134a4,4,0,0,1-2.38227-5.13077l.31452-1.487c7.26107-19.84821,31.328-32.33974,51.17618-25.07868L901.14789,398.904c19.84821,7.26106,28.4747,30.764,21.21363,50.61221l-.8276,2.24813A4,4,0,0,1,916.40315,454.14664Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M921.41132,456.03393c-129.5874,4.78153-140.91064-11.50085-101.42627-37.10467l8.37647-15.413,96,35Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 887.86152,
    cy: 394.01623,
    rx: 4.5,
    ry: 8.5,
    transform: "translate(38.43569 1022.36884) rotate(-73.26954)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M870.5,560.5a112.72659,112.72659,0,0,1-37.36206-6.32861l-1.0437-.37207a113,113,0,1,1,73.39331,1.17382c-.71069.22608-1.37964.43848-2.05933.64161-2.84033.874-5.85376,1.65918-8.93261,2.32666a111.36948,111.36948,0,0,1-16.66138,2.3125C875.42651,560.417,872.95288,560.5,870.5,560.5Zm0-220a107.01518,107.01518,0,0,0-36.36108,207.6582l.99072.353A106.71428,106.71428,0,0,0,870.5,554.5c2.3186,0,4.656-.07861,6.94751-.2334a105.48571,105.48571,0,0,0,15.77808-2.189c2.91211-.63135,5.75952-1.37354,8.46215-2.20459.66919-.2002,1.30445-.40235,1.94-.6045A107.015,107.015,0,0,0,870.5,340.5Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#ccc"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M219.5,678.5a109.66673,109.66673,0,0,0,32.33984,77.91c.86036.85,1.74024,1.7,2.62989,2.53a109.84769,109.84769,0,0,0,17.46045,13.31c1.1997.74,2.3999,1.45,3.62988,2.14a109.37915,109.37915,0,0,0,19.87988,8.73c1.18994.39,2.3999.76,3.60986,1.1A110.45367,110.45367,0,0,0,365.87012,782.34c.41992-.15.83984-.3,1.25-.45A110.0095,110.0095,0,1,0,219.5,678.5Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M306.27014,732.41564a34.0869,34.0869,0,0,1-8.804,23.076c-5.656,6.20712-14.07618,10.32359-22.57327,8.62042-7.82416-1.56828-14.18219-8.4067-13.389-16.67949a12.356,12.356,0,0,1,15.2668-11.09515c7.43265,1.92885,10.39415,12.64094,4.20051,17.66895-1.4862,1.20651-3.62136-.90358-2.12132-2.12132,4.0944-3.32384,2.8295-10.59539-2.11244-12.419-5.75371-2.12311-11.84978,2.44323-12.26355,8.32553-.49058,6.97428,4.8522,12.22647,11.40422,13.463,7.08789,1.3377,14.11532-2.29,18.91808-7.29717a30.955,30.955,0,0,0,8.474-21.54183,1.5009,1.5009,0,0,1,3,0Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.06404,
    cy: 589.46769,
    r: 53.51916,
    fill: "#01bf71"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M332.8259,720.80368l-.05567-2c3.72071-.10351,7.001-.33691,9.46583-2.13769a6.148,6.148,0,0,0,2.38134-4.52832,3.51431,3.51431,0,0,0-1.15283-2.89453c-1.63623-1.38184-4.269-.93457-6.188-.05469l-1.65478.75879,3.17334-23.19043,1.98144.27148-2.69922,19.72657c2.60743-.76661,5.02344-.43653,6.67823.96093a5.471,5.471,0,0,1,1.86035,4.49219,8.13264,8.13264,0,0,1-3.2002,6.07324C340.24875,720.59568,336.133,720.71091,332.8259,720.80368Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#2f2e41"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 134.0759,
    y: 580.22946,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 100.0759,
    y: 580.22946,
    width: 10.77148,
    height: 2,
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M299.0498,784.22A110.45367,110.45367,0,0,0,365.87012,782.34c.41992-.15.83984-.3,1.25-.45a53.27215,53.27215,0,0,0-16.9502-8.76,8.52762,8.52762,0,0,0-.02-4.7A9.45851,9.45851,0,0,0,341,761.79H327.96a9.42565,9.42565,0,0,0-9.12988,6.63,8.5633,8.5633,0,0,0-.02,4.71,53.32673,53.32673,0,0,0-15.12012,7.41q-1.39525.975-2.69971,2.04C300.33008,783.11,299.68018,783.66,299.0498,784.22Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M377.49023,692.29c0,9.02,4.44,16.5,10.21,17.8a8.25353,8.25353,0,0,0,1.79.2c6.60987,0,12-8.07,12-18,0-5.76-1.81-10.89-4.62011-14.18a11.579,11.579,0,0,0-3.53028-2.87,8.367,8.367,0,0,0-3.84961-.95,8.77375,8.77375,0,0,0-5.11035,1.72C380.31006,678.89,377.49023,685.1,377.49023,692.29Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M270.49023,692.29c0,7.76,3.27979,14.38,7.87989,16.91a8.54032,8.54032,0,0,0,4.12011,1.09,7.7302,7.7302,0,0,0,.96-.06c6.15966-.73,11.04-8.49,11.04-17.94,0-7.57-3.13037-14.06-7.55029-16.71a8.57535,8.57535,0,0,0-4.44971-1.29,8.3675,8.3675,0,0,0-3.85009.95,11.6442,11.6442,0,0,0-3.54,2.88C272.2998,681.41,270.49023,686.54,270.49023,692.29Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M279.11851,707.47448a1.50127,1.50127,0,0,0,1.42151-1.98,58.49865,58.49865,0,1,1,112.68726-6.57471,1.50006,1.50006,0,0,0,2.93554.61914,61.50091,61.50091,0,1,0-118.46557,6.91455A1.50077,1.50077,0,0,0,279.11851,707.47448Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M362.44932,663.292c2.11925,2.89278,1.07448,6.79121-1.15836,9.28528-2.90548,3.2454-7.53877,3.45016-11.5618,2.8478-4.51431-.67592-9.30261-2.79091-13.87293-1.36561-3.89537,1.21481-6.67418,4.74794-10.7211,5.63537-3.589.787-7.88081-.25477-9.139-4.08015-.60459-1.83824,2.29142-2.62611,2.89284-.79752.814,2.47478,4.32865,2.42543,6.34145,1.74013,3.22689-1.09868,5.71374-3.771,8.8854-5.0475,3.73933-1.50491,7.79621-.82548,11.60323.03181,3.58831.808,7.718,2.006,11.29267.49666,2.64515-1.11691,4.74985-4.635,2.84717-7.23211-1.1422-1.55911,1.45985-3.05739,2.59041-1.51416Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#2f2e41"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M329.5,791.5a112.79187,112.79187,0,0,1-31.28186-4.398c-1.195-.33545-2.45056-.71777-3.71179-1.13086a112.69725,112.69725,0,0,1-20.418-8.9668c-1.21777-.6831-2.44019-1.4038-3.73279-2.20068a113.09455,113.09455,0,0,1-17.93433-13.67187c-.90856-.84766-1.809-1.71778-2.68933-2.58692a112.99057,112.99057,0,1,1,118.41358,26.16455c-.41272.15088-.83972.30323-1.26685.45557A112.73884,112.73884,0,0,1,329.5,791.5Zm0-220a107.00492,107.00492,0,0,0-75.542,182.78564c.83008.81983,1.68945,1.64991,2.55835,2.46094a107.10806,107.10806,0,0,0,16.98535,12.94824c1.22461.75489,2.377,1.43409,3.526,2.07862a106.65788,106.65788,0,0,0,19.33887,8.49316c1.1875.38916,2.36084.74658,3.4945,1.06494a107.4525,107.4525,0,0,0,65.01722-1.82275l1.212-.43652A107.01355,107.01355,0,0,0,329.5,571.5Z",
    transform: "translate(-216.5 -108.5)",
    fill: "#ccc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/svg-2.7693b7dfdab91e0ad63a9f8831d6a1d1.svg";
export { ForwardRef as ReactComponent };